import { Divider, makeStyles, Typography } from "@material-ui/core";
import { CURRENCY } from "../../../utils/Constants";
import Btn from "../../Controls/Button/Button";

const useStyles = makeStyles((theme) => ({
  modalTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
  },
  modalSubTitle: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 700,
    paddingTop: "16px",
    color: theme.palette.common.normalTitle,

  },
}));

const CouponSuccess = ({
  discount,
  handleClose = () => { },
  directCheckOut,
  proceedToCheckout = () => { },
}) => {
  const classes = useStyles();
  return (
    <div className="p-4 text-center">
      <Typography
        className={`text-success pb-2 ${classes.modalTitle}`}
        variant="h1"
        align="center"
        paragraph
      >
        {"Congratulations"}
      </Typography>
      <Divider />
      <Typography
        className={classes.modalSubTitle}
        variant="h3"
        align="center"
        paragraph
      >
        Great coupon successfully applied , you saved {CURRENCY.SIGN}
        {discount} on this order
      </Typography>
      <Btn
        text="Ok"
        className="mt-3"
        handleClick={() =>
          directCheckOut ? proceedToCheckout() : handleClose()
        }
      />
    </div>
  );
};

export default CouponSuccess;
